export { default } from "./useSchoolDetailsGet";
export * from "./useSchoolDetailsGet";
